import styles from './RecruitmentProgressSection.module.scss';
import { StudyInfoPageSection, CardValue, StudyInfoCard } from '../../layoutComponents/StudyInfoPageLayout';
import { useScopedTranslation } from 'src/application/localisation/useScopedTranslation';
import { useTranslation } from 'react-i18next';
import { useGetRecruitmentProgressQuery } from 'src/services/api/api-client/StudyQuery';
import { useStudy } from 'src/helpers/hooks/useStudy';
import { AppProgress } from 'uikit/progress/AppProgress';

export const RecruitmentProgressSection = () => {
  const { id } = useStudy() ?? {};
  const { t } = useScopedTranslation('StudyInfoPage.RecruitmentProgressSection');
  const { t: tCommon } = useTranslation();

  const query = useGetRecruitmentProgressQuery({ studyId: id! }, { keepPreviousData: false, refetchOnMount: 'always' });
  const { created, planned, dropOuts, toDo, progressPercent } = query.data ?? {};

  return (
    <StudyInfoPageSection
      title={t('Title')}
      variant={'flex'}
      isLoading={query.isLoading}
      rightHeader={
        <div className={styles.rightHeader}>
          <AppProgress value={progressPercent ?? 0} max={100} />
          <div>{t('ProgressPercentage', { percentage: progressPercent ?? 0 })}</div>
        </div>
      }
    >
      <StudyInfoCard title={t('Planned')}>
        <CardValue mainText={planned?.toString() ?? tCommon('Common_dash')} />
      </StudyInfoCard>
      <StudyInfoCard title={t('Created')}>
        <CardValue mainText={created?.toString() ?? tCommon('Common_dash')} />
      </StudyInfoCard>
      <StudyInfoCard title={t('DroppedOut')}>
        <CardValue mainText={dropOuts?.toString() ?? tCommon('Common_dash')} />
      </StudyInfoCard>
      <StudyInfoCard title={t('ToDo')}>
        <CardValue mainText={toDo?.toString() ?? tCommon('Common_dash')} />
      </StudyInfoCard>
    </StudyInfoPageSection>
  );
};
